import {toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {none, some} from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {AsyncUserClaims} from 'Users/models/Claims';

export default (firstName: string, lastName: string) => `${firstName} ${lastName}`;

export const getNameFromClaims = (userClaims: AsyncUserClaims) =>
  pipe(
    userClaims,
    toEither,
    E.fold(() => none, claims => some({firstName: claims.firstName, lastName: claims.lastName}))
  );
